import React from 'react';

type VerticalPosition = 'top' | 'bottom';
type HorizontalPosition = 'left' | 'right';
type ColorScheme = 'sea' | 'forest' | 'yellow';
type IconType = 'location' | null;

interface CornerBadgeProps {
  text: string;
  onClick: () => void;
  vertical?: VerticalPosition;
  horizontal?: HorizontalPosition;
  colorScheme?: ColorScheme;
  icon?: IconType;
}

const LocationIcon = () => (
  <svg width="24" height="24" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="25" r="5" fill="#333"/>
    <circle cx="25" cy="25" r="12.5" stroke="#333" strokeWidth="3"/>
    <path d="M25 8.333V4.166M41.666 25H45.833M25 41.666V45.833M8.333 25H4.166" stroke="#333" strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

const CornerBadge: React.FC<CornerBadgeProps> = ({
  text,
  onClick,
  vertical = 'top',
  horizontal = 'right',
  colorScheme = 'sea',
  icon = null
}) => {
  const getPositionClasses = () => {
    const verticalClass = vertical === 'top' ? 'top-2 md:top-4' : 'bottom-2 md:bottom-4';
    const horizontalClass = horizontal === 'right' ? 'right-1 md:right-2' : 'left-2 md:left-6';
    return `${verticalClass} ${horizontalClass}`;
  };

  const getGradientClass = () => {
    switch (colorScheme) {
      case 'forest':
        return 'bg-gradient-to-r from-cyan-400 to-green-400';
      case 'yellow':
        return 'bg-gradient-to-r from-amber-200 to-lime-400';
      case 'sea':
      default:
        return 'bg-gradient-to-r from-blue-300 to-teal-400';
    }
  };

  return (
    <div
      className={`
        absolute
        z-20
        ${getPositionClasses()}
        flex
        items-center
        justify-center
        ${icon ? 'w-8 h-8 md:w-12 md:h-12' : 'w-28 h-8'}
        cursor-pointer
        ${getGradientClass()}
        rounded-lg
        transform
        transition-transform
        hover:scale-105
      `}
      onClick={onClick}
    >
      {icon === 'location' ? (
        <LocationIcon />
      ) : (
        <span className="relative z-10 text-gray-600 font-bold text-xs tracking-wider">{text}</span>
      )}
    </div>
  );
};

export default CornerBadge;
